import React from 'react';
import './loader.css';
export default function Loader(props) {
    return (
        <div class={props.isLoading ? '' : 'overlay spin-overlay'} hidden={props.isLoading}>
            <div className="text-center mt-5">
                <div className="w-100 float-start text-center">
                    {/* <div className="spinner-border ms-auto" role="status" /> */}

                    <img className="loader-img mt-2" src="/Images/gif/loader.gif" alt="Loading" />
                    <span class="visually-hidden"></span>
                </div>

                <div className="font-25 text-center" style={{ fontWeight: 800 }}>
                    Loading...
                </div>
            </div>
        </div>
    );
}
